import React, {Component} from 'react'
import * as _ from 'lodash';
import Question from "../question";
import PropTypes from 'prop-types';
import {List} from "immutable";
import {compose} from "redux";
import connect from "react-redux/es/connect/connect";

class Questions extends Component {

    renderQuestions() {

        return _.map(this.props.questions.toJS(), (q, i) => {
            return (
                <Question
                    key={i}
                    i={i}
                    id={q.id}
                    text={q.text}
                    mark={q.mark}
                    answer={q.answer}
                />
            );
        });
    }

    render() {

        return (
            <div className="Questions">
                {this.renderQuestions()}
            </div>
        );

    }
}

Questions.propTypes = {
    'questions': PropTypes.instanceOf(List),
}

const mapStateToProps = ({ voter }) => ({
    questions: voter.get('questions'),
})

const withConnect = connect(mapStateToProps);

export default compose(
    withConnect,
)(Questions);


// WEBPACK FOOTER //
// ./src/components/questions/index.js